import { Review } from '@core/domain/models/review.model'
import { IncidentMetadata } from '@core/domain/models/reviewItemMetadata/incidentMetadata'
import { BuiltInImportSourceId } from '@core/domain/types/builtInImportSourceId'
import { ReviewItemType } from '@core/domain/types/reviewItemType.type'
import axios from 'axios'

type DaenApiResponse = {
  reportNumber: string
  reportDate: string
  tradeName: string
  sponsor: string
  manufacturer: string
  australianRegisterTherapeuticGoodsNumber: string
  globalMedicalDeviceNomenclatureTerm: string
}

export class DaenApiClient {
  async createReviewSearch(
    review: Review,
    query: string,
  ): Promise<{
    query?: string
    filters?: string
    date: string
    reviewId: number
    importSourceId: string
    items: IncidentMetadata & { type: ReviewItemType.Incident }[]
    queryTranslation?: string
    url?: string
  }> {
    const result = await this.search({ query })
    return {
      query,
      date: new Date().toISOString(),
      reviewId: review.id,
      importSourceId: BuiltInImportSourceId.DAEN,
      items: result.map((a) => ({
        ...a,
        type: ReviewItemType.Incident,
      })),
    }
  }

  async search({
    query,
    dateFilter,
  }: {
    query: string
    dateFilter?: { startDate: string; endDate: string }
  }): Promise<IncidentMetadata[]> {
    let incidents: IncidentMetadata[] = []

    try {
      const response = await axios.post(
        '/live-scraper/daen?query=' +
          query +
          (dateFilter?.startDate ? `&startDate=${dateFilter.startDate}` : '') +
          (dateFilter?.endDate ? `&endDate=${dateFilter.endDate}` : ''),
      )
      const data: DaenApiResponse[] = response.data
      incidents = data.map((report: DaenApiResponse) =>
        this.mapToIncident(report),
      )
    } catch (error) {
      console.error('Error fetching records from DAEN API:', error)
      throw error
    }
    return incidents
  }

  private mapToIncident(report: DaenApiResponse): IncidentMetadata {
    return new IncidentMetadata({
      title: report.tradeName,
      reportNumber: report.reportNumber,
      eventDate: report.reportDate,
      eventType: '',
      reportDate: report.reportDate,
      url: '',
      summary: `${report.sponsor} ${report.manufacturer} ${report.australianRegisterTherapeuticGoodsNumber} ${report.globalMedicalDeviceNomenclatureTerm}`,
    })
  }
}
